export const getProviderLogo = (operatorId: number): string => {
  return `operator/logo/${operatorId}.svg`;
};
